import React from 'react';
import IntroNav from '../components/intro/IntroNav';
import IntroFooter from '../components/intro/IntroFooter';
import './PublicLayout.scss';

const PublicLayout = ({ children }) => {
    return (
        <div className="public-layout">
            <IntroNav />
            <main className="public-layout__main">
                {children}
            </main>
            <IntroFooter />
        </div>
    );
};

export default PublicLayout;
